<template>
    <div>
        <div id="login_welcome">
            <div id="two_fa_icon"></div>
            <div id="login_welcome_message">{{ $t('Two-Step Verification') }}</div>
            <div id="login_content_message">{{ text }}</div>
        </div>
        <div id="login_content">
            <ul id="login_credentials">
                <li>
                    <label class="login-label">{{ $t('Verification Code') }}</label>
                    <cic-textbox
                        id="password"
                        :value="value"
                        type="password"
                        @keyup.enter="$emit('change')"
                        @input="(val) => $emit('input', val)"
                    />
                    <label class="login-explain">{{ $t('Please enter your 6 digit code') }}</label>
                </li>
            </ul>

            <div id="resend_options">
                <div
                    v-if="supportedTypes.includes(1)"
                    id="resend_sms"
                    :class="{ enabled: smsSeconds === 0 }"
                    class="resend"
                    @click="resend(1)"
                >
                    <span class="resend-icon">{{ smsSeconds === 0 ? '' : smsSeconds }}</span>
                    <span class="resend-label">{{ $t('Resend my code by SMS') }}</span>
                </div>

                <div
                    v-if="supportedTypes.includes(2)"
                    id="resend_email"
                    :class="{ enabled: emailSeconds === 0 }"
                    class="resend"
                    @click="resend(2)"
                >
                    <span class="resend-icon">{{ emailSeconds === 0 ? '' : emailSeconds }}</span>
                    <span class="resend-label">{{ $t('Resend my code by email') }}</span>
                </div>
            </div>

            <div class="cic-control-bar">
                <cic-button class="ok" @click="$emit('change')">
                    {{ $t('Login') }}
                </cic-button>
            </div>

            <div v-if="$store.helpLink" id="help_link_container">
                <a id="openHelpLink" @click="openHelp">
                    {{ $t('Having trouble logging in?') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import { goToHelp } from '@/utils/Help';

    export default {
        name: 'TwoFactor',
        components: {
            CicButton,
            CicTextbox,
        },
        props: {
            supportedTypes: {
                type: Array,
                required: true,
            },
            text: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
        },
        emits: ['change', 'input', 'resend'],
        data() {
            return {
                emailSeconds: 60,
                smsSeconds: 60,
            };
        },
        created() {
            this.updateEmailTimer();
            this.updateSmsTimer();
        },
        methods: {
            openHelp() {
                goToHelp('Getting_Started.htm#Two-step_verification');
            },

            resend(type) {
                if (type === 1) {
                    this.smsSeconds = 60;
                } else {
                    this.emailSeconds = 60;
                }

                this.$emit('resend', type);
            },

            updateEmailTimer() {
                if (this.emailSeconds > 0) {
                    this.emailSeconds = this.emailSeconds - 1;
                }

                setTimeout(this.updateEmailTimer, 1000);
            },
            updateSmsTimer() {
                if (this.smsSeconds > 0) {
                    this.smsSeconds = this.smsSeconds - 1;
                }

                setTimeout(this.updateSmsTimer, 1000);
            },
        },
    };
</script>
